import type { CycleScaleData, ScaleSelectorProps } from "@qendo/profile/journal";
import { Cycle, CycleMap, type ScaleType } from "@qendo/trackables";
import { FieldGroup } from "~/components/form/FieldGroup";
import { RadioSelector } from "~/components/form/radio/RadioSelector";

export type CycleSelectorProps = ScaleSelectorProps<ScaleType.cycle>;

type CycleValue = `${Cycle}`;
type CycleTypeOption = { value: CycleValue; label: string };

function toCycleValue(cycle: Cycle | null): CycleValue | null {
    return cycle === null ? null : `${cycle}`;
}
function toCycle(cycle: CycleValue): Cycle {
    return cycle === toCycleValue(Cycle.started) ? Cycle.started : Cycle.ended;
}

const CycleOptions: CycleTypeOption[] = Object.entries(CycleMap)
    .map(([value, label]) => ({ value, label }) as CycleTypeOption)
    .reverse();

export const CycleSelector = ({ value, onUpdateScale, disabled, zIndex }: CycleSelectorProps) => {
    const cycle = toCycleValue(value.value);

    const changeCycle = (c: CycleValue) => {
        if (cycle !== c) {
            onUpdateScale({ ...value, value: toCycle(c) } as CycleScaleData);
        }
    };

    return (
        <FieldGroup zIndex={zIndex}>
            <RadioSelector<CycleValue>
                title="Your cycle"
                options={CycleOptions}
                value={cycle}
                onValueChange={changeCycle}
                columns={2}
                disabled={disabled}
            />
        </FieldGroup>
    );
};
